import { render, staticRenderFns } from "./ReportGeneral.vue?vue&type=template&id=6a435d7d"
import script from "./ReportGeneral.vue?vue&type=script&lang=js"
export * from "./ReportGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports